import { Session } from '@ais-ui/auth';
import { QueryPointResult } from '@ais-ui/websockets';

export const getTargetInfoByMMSI = async (
  session: Session,
  mmsi: number
): Promise<QueryPointResult> => {
  const response = await session.request('getTargetInfoByMMSI', { mmsi: mmsi });

  return response;
};
